import React, { useContext, useCallback, useEffect } from "react";
import GlobalModalContext from "../../../contexts/GlobalModalContext";
import RosterContext from "../../../contexts/RosterContext";
import PositionsContext from "../../../contexts/PositionsContext";
import { WBCPrimaryButton } from "../../elements/WBCPrimaryButton";
import WBCPrimaryOutlinedButton from "../../elements/WBCPrimaryOutlinedButton";
import RosterApi from "../../../httpClients/RosterApi";
import { useAlert } from "../../hooks/useAlert";
import { removeFromList } from "../../../utils/DragUtils";

const CatcherModalFooter = () => {
  // contexts && hooks
  const globalModalContext = useContext(GlobalModalContext);
  const rosterContext = useContext(RosterContext);
  const positionsContext = useContext(PositionsContext);
  const showAlert = useAlert();

  // variables
  const { teamId } = globalModalContext.state.content.team;
  const { profileId } = globalModalContext.state.content.player;
  const { posIdToAbbrev } = positionsContext.state;
  const { final } = rosterContext.state;
  const rosterDispatch = rosterContext.dispatch;
  const globalModalDispatch = globalModalContext.dispatch;
  const index = final.catchers.findIndex(p => p.profileId === profileId);

  // function(s)
  const removeFromFinalRoster = useCallback(() => {
    rosterDispatch({
      source: "catchers",
      profileId,
      type: "removeFromFinalRoster",
      list: removeFromList(final["catchers"], index)
    });
  }, [final, index, profileId, rosterDispatch]);

  // effect(s)
  useEffect(() => {
    globalModalDispatch({
      type: "setCloseCallback",
      closeCallback: removeFromFinalRoster
    });
  }, [final, index, removeFromFinalRoster, globalModalDispatch]);

  return (
    <div>
      <div className={"d-flex"}>
        <WBCPrimaryButton
          width={154}
          onClick={event => {
            event.preventDefault();
            event.stopPropagation();
            RosterApi.updatePosition(teamId, profileId, 2).then(() => {
              showAlert("Position updated");
            });
            globalModalDispatch({
              type: "closeModal"
            });
            rosterDispatch({
              type: "updatePosition",
              profileId: profileId,
              positionId: 2,
              position: posIdToAbbrev[2]
            });
          }}
        >
          Update Position
        </WBCPrimaryButton>

        <div className={"pl-2"}>
          <WBCPrimaryOutlinedButton
            onClick={event => {
              event.stopPropagation();
              globalModalContext.dispatch({
                type: "closeModal"
              });
              removeFromFinalRoster();
            }}
          >
            Cancel
          </WBCPrimaryOutlinedButton>
        </div>
      </div>
    </div>
  );
};

CatcherModalFooter.displayName = "FooterContent";

export default CatcherModalFooter;
